module.exports = __webpack_public_path__ + "static/media/boom-water.cd162a10.png";